import React from "react";
import Icon from "../Images/Icon.svg";
import Icon1 from "../Images/Icon1.svg";
import Icon2 from "../Images/Icon2.svg";
import Icon3 from "../Images/Icon3.svg";

function Section1() {
  return (
    <div className="flex flex-col items-center px-16 py-6 bg-teal-50 max-md:px-5">
      <div className="mt-1 text-lg font-bold leading-7 text-cyan-700 uppercase">
        Let’s Get Started
      </div>
      <div className="mt-2 text-5xl font-semibold tracking-wide text-center capitalize leading-[52.08px] text-zinc-800">
        our sub companies
      </div>
      <div className="self-stretch mt-8 mb-6 max-md:mt-10 max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow items-center px-3.5 py-16 w-full bg-white rounded-md shadow-lg max-md:mt-9">
              <div className="flex items-center justify-center w-[100px] h-[100px] bg-white rounded-[50px] shadow-[5px_7px_16px_1px_#85858529]">
                <img alt="House traced" src={Icon3} />
              </div>
              <div className="mt-10 text-2xl font-medium leading-7 text-cyan-700">
                1. Consultation
              </div>
              <div className="self-stretch mt-4 text-sm leading-6 text-center text-slate-500">
                Our team will conduct a thorough assessment of your energy
                needs.
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow items-center px-3.5 py-16 w-full bg-white rounded-md shadow-lg max-md:mt-10">
              <div className="flex items-center justify-center w-[100px] h-[100px] bg-white rounded-[50px] shadow-[5px_7px_16px_1px_#85858529]">
                <img alt="House traced" src={Icon1} />
              </div>
              <div className="mt-10 text-2xl font-medium leading-7 text-cyan-700 max-md:mt-10">
                2. Installation
              </div>
              <div className="self-stretch mt-4 text-sm leading-6 text-center text-slate-500">
                Our expert technicians will install your solar panels with
                precision and care.
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow items-center px-3.5 py-16 w-full bg-white rounded-md shadow-lg max-md:mt-10">
              <div className="flex items-center justify-center w-[100px] h-[100px] bg-white rounded-[50px] shadow-[5px_7px_16px_1px_#85858529]">
                <img alt="House traced" src={Icon2} />
              </div>
              <div className="mt-10 text-2xl font-medium leading-7 text-cyan-700 max-md:mt-10">
                3. Monitoring
              </div>
              <div className="self-stretch mt-4 text-sm leading-6 text-center text-slate-500">
                We'll ensure your system is running efficiently and effectively
                for years to come.
                <br />
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow items-center px-3.5 py-16 w-full bg-white rounded-md shadow-lg max-md:mt-9">
              <div className="flex items-center justify-center w-[100px] h-[100px] bg-white rounded-[50px] shadow-[5px_7px_16px_1px_#85858529]">
                <img alt="House traced" src={Icon3} />
              </div>
              <div className="mt-10 text-2xl font-medium leading-7 text-cyan-700">
                4. Maintaining
              </div>
              <div className="self-stretch mt-4 text-sm leading-6 text-center text-slate-500">
                Our team will conduct a thorough assessment of your energy
                needs.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section1;
